import { render, staticRenderFns } from "./aLteAside.vue?vue&type=template&id=385d8265"
import script from "./aLteAside.vue?vue&type=script&lang=js"
export * from "./aLteAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('385d8265', component.options)
    } else {
      api.reload('385d8265', component.options)
    }
    module.hot.accept("./aLteAside.vue?vue&type=template&id=385d8265", function () {
      api.rerender('385d8265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/aLteAside.vue"
export default component.exports